import { DateTimeISO, Money, PaginatedResponse, User } from './common';
import { SelectOption } from './inputs';
import { AccountOrigins, OwnershipType, TransferType } from './transactions';

export enum TRANSACTION_REQUEST_STATUS {
  Pending,
  Approved,
  Declined,
  Canceled,
  Expired,
  UnderReview,
}

export enum TRANSACTION_DELIVERY {
  Standard,
  Express,
  SameDay,
}

export interface TransactionRequestItem {
  status: TRANSACTION_REQUEST_STATUS;
  uuid: string;
  requestedAt: string;
  expirationAt: string;
  approvedAt: string | null;
  declinedAt: string | null;
  canceledAt: string | null;
  amount: Money;
  displayAmount: string;
  description: string;
  deliverySpeed: TRANSACTION_DELIVERY;
  owner: User;
  requestedBy: User;
}

export type TransactionRequestResponse =
  PaginatedResponse<TransactionRequestItem>;

export type TransactionRequestDetailsAccount = {
  bankAccountOrigin: AccountOrigins;
  ownershipType?: OwnershipType;
  bankLogoUrl?: string;
};

export type TransactionRequestDetails = {
  status: TRANSACTION_REQUEST_STATUS;
  transactionType: 1;
  requestedAt: DateTimeISO;
  requestedBy: User;
  expirationAt?: DateTimeISO;
  approvedAt?: DateTimeISO;
  approvedBy?: User;
  declinedAt?: DateTimeISO;
  declinedBy?: User;
  canceledAt?: DateTimeISO;
  canceledBy?: User;
  owner: User;
  originationMethod?: string;
  amount: Money;
  displayAmount: string;
  description: string;
  fromAccount: string;
  fromAccountDetails: TransactionRequestDetailsAccount;
  toAccount: string;
  toAccountDetails: TransactionRequestDetailsAccount;
  bankLogoUrl: string;
  deliverySpeed: TRANSACTION_DELIVERY;
  note: string;
  initiatedByAuthorizedTeammate: boolean;
  skipCustomerReview: boolean;
};

export enum TransactionPurpose {
  PAY_FOR_GOODS_OR_SERVICES = 'Pay for goods or services',
  BUY_PROPERTY_OR_INVEST = 'Buy property or invest',
  PAY_BUSINESS_OR_GOVERNMENT = 'Pay business or government',
  INVEST_IN_CRYPTO = 'Invest in crypto',
  PAY_FRIEND_OR_FAMILY = 'Pay friend or family',
  OTHER = 'Other',
}

export type TransactionRequestSelectionItem = SelectOption &
  (
    | {
        isInternalAccount: true;
        availableBalance: Money;
        bankAddressCountryCode?: never;
        callerIsAuthorizedTeammate: boolean;
      }
    | {
        isInternalAccount: false;
        availableBalance?: never;
        bankAddressCountryCode: string;
        callerIsAuthorizedTeammate?: never;
      }
  );

export type TransactionType = 'deposit' | 'withdrawal' | 'transfer' | 'wire';
export type CreateTransactionRequest = {
  customerId?: string;
  fromAccountId?: string;
  toAccountId?: string;
  amount?: string;
  transactionType?: TransactionType;
  speed?: TransferType;
  note?: string;
  instructions?: string;
  requestExceedingLimitException?: boolean;
  skipCustomerReview?: boolean;
  purpose?: TransactionPurpose | '';
};

export type CreateTransactionResponse = {
  id: string;
  requiresStaffReview: false;
  skipCustomerReview: false;
  initiatedByAuthorizedTeammate: false;
  requestExceedingLimitException: false;
};

export const queryKeys = {
  list: ['transactionRequestList'] as const,
  details: ['transcationRequestDetails'] as const,
};
